import { rem } from 'polished'
import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

const LoadingBarContainer = styled.div`
  position: relative;
  width: 100%;
  height: 0;
`

const LoadingBar = styled.div`
  height: ${rem(5)};
  background-color: ${(props) => props.theme.palette.neutral.default.two};
  transition:  width 1s ease-in-out;
  position: absolute;
  top: 0;
  left: 0;
`

const PROGRESS_MOVEMENT_MS = 50

export default function FlightsLoadingTopBar() {
  const [progress, setProgress] = useState(0)
  const startTimeRef = useRef(Date.now())

  useEffect(() => {
    const interval = setInterval(() => {
      const elapsedTime = Date.now() - startTimeRef.current
      setProgress((Math.atan(elapsedTime / 3e3) / (Math.PI / 2)) * 100)
    }, PROGRESS_MOVEMENT_MS)

    return () => clearInterval(interval)
  }, [])

  return (
    <LoadingBarContainer>
      <LoadingBar style={{ width: `${progress}%` }} />
    </LoadingBarContainer>
  )
}
